<template>
  <van-checkbox
    v-model="chked"
    @change="handleChange"
  >
    <slot></slot>
    <svg-icon
      slot="icon"
      slot-scope="props"
      cls="type-icon"
      :icon="chked ? 'checkbox' : 'uncheckbox'"
    >
    </svg-icon>
  </van-checkbox>
</template>
<script>

import SvgIcon from './SvgIcon'

export default {
  name: 'CheckBox',
  model: {
    prop: 'checked',
    event: 'chk-change'
  },
  components: {
    SvgIcon
  },
  props: {
    checked: Boolean
  },
  data () {
    return {
      chked: this.checked
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('chk-change', value)
    }
  }
}
</script>
<style lang="postcss">
.van-checkbox {
  & .type-icon {

  }
}
</style>
